import { Navigate } from 'react-router-dom';

export const getStoreAuth = () => {
  try { return JSON.parse(localStorage.getItem('store_panel_auth')); } catch { return null; }
};

export default function StorePanelPrivateRoute({ children }) {
  return getStoreAuth()?.token ? children : <Navigate to="/store-login" replace />;
}